import { Backdrop, CircularProgress } from "@mui/material";
import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { NewRequestContextProvider } from "../contexts/NewRequestContext";
import { ApplicationsByCategory } from "../views/admin/ApplicationsByCategory";
import { Report } from "../views/admin/Report";
import { Statistics } from "../views/admin/Statistics";
import { Users } from "../views/admin/Users";
import { Login } from "../views/auth/Login";
import { Dashboard } from "../views/Dashboard";
import { Maintenance } from "../views/layouts/Maintenance";
import { NotFound } from "../views/layouts/NotFound";
import { NewRequest } from "../views/NewRequest";
import { Application } from "../views/operator/application/Application";
import { Applications } from "../views/operator/application/Applications";
import { People } from "../views/operator/person/People";
import { Person } from "../views/operator/person/Person";
import { Entries } from "../views/operator/rejected/Entries";
import { NewEntry } from "../views/operator/rejected/NewEntry";
import { Rejected } from "../views/operator/rejected/Rejected";
import { PrivateRoute } from "./PrivateRoute";
import { PublicRoute } from "./PublicRoute";

export const AppRouter = () => {
  const isInMaintenance = false;

  return (
    <Router>
      <React.Suspense
        fallback={
          <Backdrop open>
            <CircularProgress />
          </Backdrop>
        }
      >
        {isInMaintenance ? (
          <Routes>
            <Route path="*" element={<Maintenance />} />{" "}
          </Routes>
        ) : (
          <Routes>
            <Route element={<PublicRoute />}>
              <Route path="/" element={<Login />} />
            </Route>
            <Route element={<PrivateRoute roles={undefined} />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route
                path="/nueva-entrada"
                element={
                  <NewRequestContextProvider>
                    <NewEntry />
                  </NewRequestContextProvider>
                }
              />
              <Route
                path="/nueva-solicitud"
                element={
                  <NewRequestContextProvider>
                    <NewRequest />
                  </NewRequestContextProvider>
                }
              />
              <Route
                path="/nueva-solicitud/:idApplication"
                element={
                  <NewRequestContextProvider>
                    <NewRequest />
                  </NewRequestContextProvider>
                }
              />
              <Route
                path="/editar/:idApplication"
                element={
                  <NewRequestContextProvider>
                    <NewRequest />
                  </NewRequestContextProvider>
                }
              />
              <Route path="/entradas" element={<Entries />} />
              <Route path="/entrada/:idRejected" element={<Rejected />} />
              <Route path="/solicitud/:idApplication" element={<Application />} />
              <Route path="/ciudadanos" element={<People />} />
              <Route path="/ciudadano/:idPerson" element={<Person />} />
              <Route path="/solicitudes" element={<Applications type="success" />} />
              <Route path="/solicitudes/:year/:category/:unit" element={<ApplicationsByCategory />} />
              <Route path="/solicitudes-pendientes" element={<Applications type="complete" />} />
              <Route path="/solicitudes-en-progreso" element={<Applications type="progress" />} />
              <Route path="/estadisticas" element={<Statistics />} />
              <Route path="/estadisticas/:year" element={<Report />} />
            </Route>
            <Route element={<PrivateRoute roles={["admin"]} />}>
              <Route path="/usuarios" element={<Users />} />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        )}

        <ToastContainer />
      </React.Suspense>
    </Router>
  );
};
